import React, { useState, useEffect } from "react";
import { Grid, Box, Button } from "@mui/material";
import logo from "../tarteeb.png";
import logo2 from "../logo1.png";
import skipcash from "../skipcash.png";
import { useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import "../App.css";

export default function RowAndColumnSpacing() {
	const history = useHistory();
	const [display, setDisplay] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setDisplay(true);
		}, 1500);
	}, []);

	return (
		<Box sx={{ minHeight: "100vh", width: "100%", backgroundColor: "#F4F4F5" }}>
			<Grid container direction="column">
				<Grid container direction="row" style={{ backgroundColor: "white" }}>
					<Grid
						item
						xs={6}
						style={{
							display: "flex",
							alignSelf: "center",
							justifyContent: "flex-end",
							paddingRight: "0.5%",
						}}
					>
						<img
							alt="tarteeb-logo"
							src={logo}
							style={{ height: 150, width: 200 }}
						/>
					</Grid>
					<Grid
						item
						xs={6}
						style={{
							display: "flex",
							alignSelf: "center",
							justifyContent: "flex-start",
							paddingRight: "0.5%",
						}}
					>
						<img
							alt="rwaiha-logo"
							src={logo2}
							style={{ height: 120, width: 160 }}
						/>
					</Grid>
				</Grid>
				<Grid
					style={{ marginBottom: "10%", width: "100%" }}
					container
					direction="column"
					alignItems="center"
				>
					<h1
						style={{
							fontFamily: "Poppins",
							fontSize: 60,
							color: "#a67a31",
							textAlign: "center",
						}}
					>
						Coming Soon
					</h1>
				</Grid>

				{/* <Grid item xs={12}>
          <h3>Date</h3>
          <h4>20 September, 2021</h4>
        </Grid>
        <Grid item xs={12}>
          <h3>Time</h3>
          <h4>20 September, 2021</h4>
        </Grid>
        <Grid item xs={12}>
          <h3>Address</h3>
          <h4>Doha Exhibtion and Convention Center</h4>
        </Grid> */}
				{/* <CSSTransition
          in={display}
          timeout={2000}
          classNames="display"
          unmountOnExit
        >
          <Grid
            style={{ marginBottom: "10%", width: "100%" }}
            container
            direction="column"
            alignItems="center"
          >
            <Grid item xs={12} style={{ marginTop: "10%" }}>
              <h1
                style={{
                  fontFamily: "Poppins",
                  fontSize: 60,
                  color: "#a67a31",
                  textAlign: "center",
                }}
              >
                Book Your Spot
              </h1>
              <h1
                style={{
                  fontFamily: "Poppins",
                  fontSize: 60,
                  color: "#a67a31",
                  textAlign: "center",
                }}
              >
                إحجز مساحتك
              </h1>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <Button
                variant="outlined"
                className="button"
                onClick={() => history.push("/exhibitor")}
                style={{
                  width: "50%",
                  height: "10vh",
                  fontSize: 15,
                  fontFamily: "Poppins",
                  color: "white",
                  borderColor: "#a67a31",
                  backgroundColor: "#a67a31",
                }}
              >
                Click Here to Book
              </Button>
            </Grid>
          </Grid>
        </CSSTransition> */}
				<Grid container justifyContent="center">
					<img alt="skipcash" src={skipcash} />
				</Grid>
			</Grid>
		</Box>
	);
}
